var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',_vm._g({attrs:{"title":_vm.tabTitle,"title-item-class":{'right-tab': _vm.alignRight },"active":_vm.active,"lazy":_vm.lazy,"disabled":_vm.disabled},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("tab-title")]},proxy:true}],null,true)},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }